export enum PropertySubtypes {
  agricultural = 'Agricultural',
  airport = 'Airport',
  assistedLivingFacility = 'Assisted Living Facility',
  behavioralHealthHospital = 'Behavioral Health Hospital',
  bigBox = 'Big Box',
  bioManufacturing = 'Bio-manufacturing',
  commuterRail = 'Commuter Rail',
  conventional = 'Conventional',
  coworking = 'Coworking',
  creative = 'Creative',
  dataCenter = 'Data Center',
  developmentSiteWithProForma = 'Development Site with Pro-Forma',
  distribution = 'Distribution',
  educational = 'Educational',
  filmStudio = 'Film Studio',
  freestanding = 'Freestanding',
  generalHospital = 'General Hospital',
  generalWarehouse = 'General Warehouse',
  government = 'Government',
  healthcare = 'Healthcare',
  hotel = 'Hotel',
  industrial = 'Industrial',
  labRD = 'Lab R&D',
  lifeScience = 'Life Science',
  lowIncomeUse = 'Low Income-Use',
  ltacHospital = 'LTAC Hospital',
  manufacturing = 'Manufacturing',
  medicalCondo = 'Medical Condo',
  medicalOutpatient = 'Medical Outpatient',
  medicalRetail = 'Medical Retail',
  mixedUse = 'Mixed-Use',
  motel = 'Motel',
  multifamily = 'Multifamily',
  office = 'Office',
  officeShowroom = 'Office Showroom',
  parkingLot = 'Parking Lot',
  port = 'Port',
  powerCenter = 'Power Center',
  rail = 'Rail',
  rD = 'R&D',
  regionalMall = 'Regional Mall',
  rehabilitationHospital = 'Rehabilitation Hospital',
  retail = 'Retail',
  selfStorage = 'Self Storage',
  seniorHousing = 'Senior Housing',
  skilledNursingFacility = 'Skilled Nursing Facility',
  stripMall = 'Strip Mall',
  studentHousing = 'Student Housing',
  subway = 'Subway',
  vacantLand = 'Vacant Land',
  carrierHotel = 'Carrier Hotel',
  colocation = 'Colocation',
  edge = 'Edge',
  enterprise = 'Enterprise',
  hyperscapeCloud = 'Hyperscale/Cloud',
  outdoorStorage = 'Outdoor Storage',
  singleFamily = 'Single-family',
  communityNeighborhoodCenter = 'Community/Neighborhood Center',
  lifestyleCenter = 'Lifestyle Center',
  outletCenter = 'Outlet Center',
  streetFront = 'Street Front',
  urbanRetail = 'Urban Retail',
}
